import { Dropdown, List } from 'antd';
import ItemMenu, { ItemMenuProps } from './ItemMenu';
import { styled } from 'styled-components';
import { useState } from 'react';

interface MenuActionProps {
  listMenu: ItemMenuProps[];
  children?: React.ReactNode;
  onClick?: (item: ItemMenuProps) => void;
}

const MenuAction = ({ listMenu, children, onClick }: MenuActionProps) => {
  const [open, setOpen] = useState(false);

  const handleItemClick = (item: ItemMenuProps) => {
    if (onClick) {
      onClick(item);
    }
    setOpen(false);
  };
  
  return (
    <Dropdown
      open={open}
      onOpenChange={(flag) => setOpen(flag)}
      dropdownRender={() => (
        <StyledMenuWrapper>
          <List
            dataSource={listMenu}
            renderItem={(item) => <ItemMenu key={item?.title} {...item} onClick={() => handleItemClick(item)}/>}
          />
        </StyledMenuWrapper>
      )}
      trigger={['click']}
    >
      {children}
    </Dropdown>
  );
};

export default MenuAction;

const StyledMenuWrapper = styled.div`
  padding: 4px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
`;
